import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createChain, type CreateChainBody } from "../api/chains";
import type { ChainSummary } from "../types/chain";

export function useCreateChain() {
  const qc = useQueryClient();
  return useMutation<ChainSummary, Error, CreateChainBody>({
    mutationFn: createChain,
    onSuccess: (created) => {
      qc.setQueryData<ChainSummary[]>(["chains"], (old) => {
        if (!old) return [created];
        if (old.some((c) => c.id === created.id)) return old;
        return [...old, created];
      });
      qc.invalidateQueries({ queryKey: ["chains"] });
    },
  });
}
